<!--
  The attach dialog (§14.3). Search, tick, see what the whole selection will do, confirm.

  The consequence sentence is at the bottom because it is a summary of everything above it and it
  CHANGES as boxes are ticked - a user has to be able to watch it change.
-->
<h2 mat-dialog-title>Attach documents</h2>

<mat-dialog-content class="dad">

    <mat-form-field appearance="outline" class="dad__search" *ngIf="!isEmpty">
        <mat-label>Search documents</mat-label>
        <input matInput [(ngModel)]="search" [ngModelOptions]="{ standalone: true }"
            placeholder="Name or category" data-test="picker-search">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <!--
      A practice with nothing to attach. The chip row hides itself rather than drawing this, so the
      only way here is a menu item that had to open something - and an empty box would tell that
      user nothing at all.
    -->
    <p class="dad__hint" *ngIf="isEmpty" data-test="picker-empty">{{ emptyMessage }}</p>

    <div class="dad__list" *ngIf="!isEmpty">
        <div class="dad__row" *ngFor="let document of visibleDocuments; trackBy: trackById"
            [class.dad__row--selected]="isSelected(document)" data-test="picker-option">

            <mat-checkbox [checked]="isSelected(document)" (change)="toggle(document)"
                [attr.data-test-document]="document.id">
                <span class="dad__name">{{ document.name }}</span>
            </mat-checkbox>

            <div class="dad__meta">
                <span class="dad__category" *ngIf="document.category" data-test="picker-category">
                    {{ document.category }}
                </span>

                <!--
                  24.2 - WHEN a trigger would send this, where one put it on offer. "3 days before"
                  is the thing a receptionist needs to see before overriding it.
                -->
                <span class="dad__trigger" *ngIf="trigger(document)">
                    <mat-icon>schedule</mat-icon>
                    <!-- The data-test is on the TEXT, not on the wrapper: a `mat-icon` renders its
                         ligature as text content, so a wrapper reads as "schedule3 days before". -->
                    <span data-test="picker-trigger">{{ trigger(document) }}</span>
                </span>

                <!--
                  14.2 - the state that changes what the patient receives, said plainly and in the
                  settings tab's own words. Never the boolean, in either direction.
                -->
                <span class="dad__response" data-test="picker-response-mode"
                    [class.dad__response--information]="!requiresResponse(document)">
                    <mat-icon>{{ responseModeIcon(document) }}</mat-icon>
                    <span>{{ responseModeSentence(document) }}</span>
                </span>
            </div>

            <p class="dad__description" *ngIf="document.description">{{ document.description }}</p>
        </div>
    </div>

    <p class="dad__hint" *ngIf="isFilteredEmpty" data-test="picker-no-matches">
        No document matches &ldquo;{{ search }}&rdquo;.
    </p>

    <!-- Ticked, and hidden by the search. It is still going out, so it is still counted. -->
    <p class="dad__hint" *ngIf="hiddenSelectedCount" data-test="picker-hidden-selected">
        {{ hiddenSelectedCount }} selected document(s) are hidden by this search, and are still
        included.
    </p>

    <!--
      WHAT THE SELECTION AS A WHOLE WILL DO (14.4). The sentence that earns this component: it
      changes when the MIX changes, not when the count does.
    -->
    <!--
      The consequence sentence, without the panel around it. It says what the SELECTION does — a
      fact about the mix that no individual row carries — so it stays; the coloured block did not
      earn the weight it was pulling.
    -->
    <p class="dad__consequence" *ngIf="consequence" data-test="dialog-consequence">
        <span class="dad__count" data-test="dialog-count">{{ selectedCount }}</span>
        {{ consequence }}
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()" data-test="dialog-cancel">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="confirm()"
        data-test="dialog-confirm">Done</button>
</mat-dialog-actions>
